var map = {
	"./1.jpg": 948,
	"./2.jpg": 242,
	"./3.jpg": 1,
	"./4.jpg": 638,
	"./5.jpg": 136,
	"./6.jpg": 961,
	"./7.jpg": 466,
	"./8.jpg": 409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;